import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import App from "./App";
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import AwsConfigAuth from './aws-config/auth';

// Amplifyライブラリの初期化
Amplify.configure({ Auth: AwsConfigAuth })

// Create browser history to use in the Redux store
const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(history);
store.dispatch({
    type: "INIT_APP",
});

//  set CurrentUrl for navigate 
const url:string = (window.location.pathname + window.location.search).slice(1);
const list_code:any = ["ABAC","AD","GB","GC","EBEC","BX","BE","FE"];
for(const item of list_code){
    if(url != "" && url.includes(`telemetry/${item.toLowerCase()}?path=root`)){
        if(!localStorage.getItem('currentUrl')){
            localStorage.setItem('currentUrl', (window.location.pathname + window.location.search).slice(1));
        }
        break;
    }
}

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);
